module.exports = __webpack_public_path__ + "static/img/avatar_6.847404d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/avatars/avatar_6.png
// module id = Y8qo
// module chunks = 0